/**
 * Cliente admin de Orborix Fit (F5) — curación de videos del catálogo.
 * `/api/admin/fit/exercises` (lista + filtros) y el PATCH de la URL curada.
 */
import { get, patchJsonAdmin } from './_core.js';

export interface AdminFitExercise {
  id: string;
  nameEn: string;
  nameEs: string | null;
  bodyPart: string;
  equipment: string;
  target: string;
  difficulty: string | null;
  gifUrl: string | null;
  curatedVideoUrl: string | null;
}

export interface AdminFitExerciseQuery {
  q?: string;
  bodyPart?: string;
  equipment?: string;
  curated?: 'yes' | 'no';
  page?: number;
  pageSize?: number;
}

export interface AdminFitExerciseList {
  items: AdminFitExercise[];
  total: number;
  page: number;
  pageSize: number;
}

export async function fetchFitExercises(
  query: AdminFitExerciseQuery = {},
): Promise<AdminFitExerciseList> {
  const qs = new URLSearchParams();
  if (query.q) qs.set('q', query.q);
  if (query.bodyPart) qs.set('bodyPart', query.bodyPart);
  if (query.equipment) qs.set('equipment', query.equipment);
  if (query.curated) qs.set('curated', query.curated);
  if (query.page) qs.set('page', String(query.page));
  if (query.pageSize) qs.set('pageSize', String(query.pageSize));
  const s = qs.toString();
  const res = await get<{ items: AdminFitExercise[]; page: number; pageSize: number }>(
    `/admin/fit/exercises${s ? `?${s}` : ''}`,
  );
  return {
    items: res.data.items,
    total: res.meta?.total ?? res.data.items.length,
    page: res.data.page,
    pageSize: res.data.pageSize,
  };
}

/** Fija (url http(s)) o limpia (null) la URL de video curado de un ejercicio. */
export function setFitCuratedVideo(id: string, url: string | null): Promise<AdminFitExercise> {
  return patchJsonAdmin<AdminFitExercise>(
    `/admin/fit/exercises/${encodeURIComponent(id)}/video`,
    { url },
  );
}
